import { usePopup } from 'hooks/usePopup';

import AccountNumberHelpPopup from './AccountNumberHelpPopup';

export const useAccountNumberHelpPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showAccountNumberHelpPopup = () => {
    showPopup(<AccountNumberHelpPopup onClose={() => hidePopup()} />, { keepPopups: true });
  };

  return { showAccountNumberHelpPopup };
};
